import { Component } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-risk',
  templateUrl: './risk.component.html',
  standalone: false,
  styleUrls: ['./risk.component.scss']
})
export class RiskComponent {

  barChartSettings = {
    showXAxis: true,
    showYAxis: true,
    gradient: true,
    showLegend: false,
    showXAxisLabel: true,
    xAxisLabel: 'Failure reason',
    showYAxisLabel: true,
    yAxisLabel: 'Count',
    data: []
  };

  countryWiseFailureData: any;

  countryWiseFailurePieChartSettings = {
    doughnut: true,
    gradient: true,
    showLabels: true,
    legend: false
  }


  riskData: any;

  colorScheme: Color = {
    name: "custom",
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      "#0d30da", "#ff7043", "#00bcd4", "#5e35b1", "#66bb6a"
    ],
  };


  constructor(private _apiService: ApiService) {

  }


  ngOnInit() {
    const vm = this;
    vm.getRiskData();
  }

  getRiskData() {
    const vm = this;
    vm._apiService.postData('/dashboard/transaction-status', {}).subscribe((res: any) => {
      if (res && !res.error) {
        vm.riskData = res.data.stats;
        vm.barChartSettings.data = res.data.data.map((item: any) => ({
          name: item.name,
          value: item.value
        }));
        vm.countryWiseFailureData = res.data.countryWiseFilures.map((item: any) => ({
          name: item.name,
          value: item.value
        }));
      }
    });
  }
}
